module.exports = {"371327001":"十字路街道","371327102":"大店镇","371327103":"坊前镇","371327106":"板泉镇","371327107":"洙边镇","371327108":"文疃镇","371327111":"石莲子镇","371327112":"岭泉镇","371327113":"筵宾镇","371327114":"涝坡镇","371327116":"道口镇","371327117":"相沟镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371327.json
// module id = 1350
// module chunks = 0